import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./TravelExperience.css";
import Heading from "../../../utls/Heading";

const TravelExperience = () => {
  return (
    <>
      <div className="container TravelExperience EmpoweringSection ">
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex justify-content-center align-items-center flex-column">
              <Heading className="customheadings">
                <span>Personalized </span>Travel Experiences
              </Heading>
              <p className="experienceP mt-2 mt-md-2">
                Today’s corporate traveler seeks the opportunity to relax and
                recharge after meetings. Our personalized Bleisure travel
                solutions combine work with leisure, offering a perfect balance
                of productivity and peace. In case you’re moving for a weekend
                getaway or exploring new destinations,
              </p>
              <p className="text-center bbt-help mt-3 mt-md-0">
                Blueberry Travel can make it happen with ease!
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container six-btn ">
        <div className="row px-md-5">
          <div className="col-lg-6 col-md-12 col-12 d-flex justify-content-center position-relative">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/Itinerary.png"
              alt=""
              className="left-img"
              loading="lazy"
            />
            <div className="left-btn-wrapper mb-3">
              <h5 className="fw-bold">Customized Travel Iterinaries</h5>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12 position-relative">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/Luxe.png"
              alt=""
              className="right-img"
              loading="lazy"
            />
            <div className="right-btn-wrapper mb-3">
              <h5 className="fw-bold">Luxe Leisure Destination Inputs</h5>
            </div>
          </div>
        </div>

        <div className="row px-md-5">
          <div className="col-lg-6 col-md-12 col-12 d-flex justify-content-center position-relative">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/Car%20rentals.png"
              alt=""
              className="left-img"
              loading="lazy"
            />
            <div className="left-btn-wrapper mb-3 ">
              <h5 className="fw-bold">Travel, Lodging and Car Rentals</h5>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12 position-relative">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/Accomodation.png"
              alt=""
              className="right-img"
              loading="lazy"
            />
            <div className="right-btn-wrapper mb-3">
              <h5 className="fw-bold ">Access to Luxury Accommodation</h5>
            </div>
          </div>
        </div>

        <div className="row px-md-5">
          <div className="col-lg-6 col-md-12 col-12 d-flex justify-content-center position-relative">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/Cruise.png"
              alt=""
              className="left-img"
              loading="lazy"
            />
            <div className="left-btn-wrapper mb-3">
              <h5 className="fw-bold">Traveling in Style and Taking Cruises</h5>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12 position-relative">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/Travel%20insurance.png"
              alt=""
              className="right-img"
              loading="lazy"
            />
            <div className="right-btn-wrapper mb-3">
              <h5 className="fw-bold ">Travel Insurance</h5>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TravelExperience;
